"use strict";
import React from "react";

const ApiSandbox = () => {
    return <div>API Sandbox</div>;
};

export default ApiSandbox;
